import { RetryLink } from 'apollo-link-retry';

// Look @ ApolloRetryErrorLink.md for the documented behavior of this link.
// If you're making changes here, also be sure to update the documentation.
export const createRetryErrorLink = () => {
  return new RetryLink({
    delay: {
      initial: 300,
      max: Infinity,
      jitter: true
    },
    attempts: {
      max: 3,
      retryIf: (error, _operation) => (error ? true : false)
    }
  });
};
